export const commonAppHelperMethods = {


    formatDateToLocale(date) {
        if (date === null || date === undefined) {
            return null;
        }

        var dateObj = new Date(date);
        return dateObj.toLocaleDateString();
    },
    formatDatetimeToLocaleFormat(datetime){
        if (datetime === null || datetime === undefined) {
            return null;
        }

        var dateObj = new Date(datetime);
        // format datetime to pattern dd.MM.yyyy HH:mm:ss
        return dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString();

    },
    formatDateToISO(date) {
        if (date === null || date === undefined) {
            return null;
        }

        var dateObj = new Date(date);
        return dateObj.toISOString().split('T')[0];
    },


    formatTime(daySeconds) {
        var hours = Math.floor(daySeconds / 3600);
        var minutes = Math.floor((daySeconds - (hours * 3600)) / 60);
        var seconds = daySeconds - (hours * 3600) - (minutes * 60);

        return hours + ":" + minutes + ":" + seconds;
    },
    numberToTextPLN(amount) {
        if(amount == null){
            return null;
        }

        const units = ["", "jeden", "dwa", "trzy", "cztery", "pięć", "sześć", "siedem", "osiem", "dziewięć"];
        const teens = ["dziesięć", "jedenaście", "dwanaście", "trzynaście", "czternaście", "piętnaście", "szesnaście", "siedemnaście", "osiemnaście", "dziewiętnaście"];
        const tens = ["", "", "dwadzieścia", "trzydzieści", "czterdzieści", "pięćdziesiąt", "sześćdziesiąt", "siedemdziesiąt", "osiemdziesiąt", "dziewięćdziesiąt"];
        const hundreds = ["", "sto", "dwieście", "trzysta", "czterysta", "pięćset", "sześćset", "siedemset", "osiemset", "dziewięćset"];

        const zlCases = ["złoty", "złote", "złotych"];
        const grCases = ["grosz", "grosze", "groszy"];
        const thousandCases = ["tysiąc", "tysiące", "tysięcy"];
        const millionCases = ["milion", "miliony", "milionów"];

        // Helper function to handle cases (1, 2-4, 5-)
        function getCase(value, cases) {
            if (value === 1) return cases[0];
            if (value >= 2 && value <= 4) return cases[1];
            return cases[2];
        }

        // Function to convert three-digit number to text
        function convertHundreds(n) {
            const hundred = Math.floor(n / 100);
            const ten = Math.floor((n % 100) / 10);
            const unit = n % 10;

            if (ten === 1) return `${hundreds[hundred]} ${teens[unit]}`.trim();
            return `${hundreds[hundred]} ${tens[ten]} ${units[unit]}`.trim();
        }

        // Function to convert large numbers (thousands, millions)
        function convertLargeNumber(n, cases) {
            if (n === 0) return "";
            if (n === 1) return `jeden ${cases[0]}`;

            const result = convertHundreds(n);
            return `${result} ${getCase(n, cases)}`.trim();
        }

        // Split amount into złoty and grosz
        const zl = Math.floor(amount);  // Złoty
        const gr = Math.round((amount - zl) * 100);  // Grosze

        // Convert złoty part to text (handle millions, thousands, and hundreds)
        let zlText = "";
        const millions = Math.floor(zl / 1000000);
        const thousands = Math.floor((zl % 1000000) / 1000);
        const remainder = zl % 1000;

        if (millions > 0) {
            zlText += `${convertLargeNumber(millions, millionCases)} `;
        }
        if (thousands > 0) {
            zlText += `${convertLargeNumber(thousands, thousandCases)} `;
        }
        zlText += `${convertHundreds(remainder)} ${getCase(remainder, zlCases)}`.trim();

        // Convert grosz part to text
        let grText = "";
        if (gr === 0) {
            grText = "zero groszy";
        } else {
            grText = `${convertHundreds(gr)} ${getCase(gr, grCases)}`;
        }

        return `${zlText.trim()} i ${grText}`.trim();
    }

};
